import { render, staticRenderFns } from "./footwear.vue?vue&type=template&id=2e062464"
import script from "./footwear.vue?vue&type=script&lang=js"
export * from "./footwear.vue?vue&type=script&lang=js"
import style0 from "./footwear.vue?vue&type=style&index=0&id=2e062464&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e062464')) {
      api.createRecord('2e062464', component.options)
    } else {
      api.reload('2e062464', component.options)
    }
    module.hot.accept("./footwear.vue?vue&type=template&id=2e062464", function () {
      api.rerender('2e062464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/tabs/footwear.vue"
export default component.exports